import { InsightFilterType } from '../apis/PythonInsightsAPI';

export const insightsQueryKeys = {
  insights: ({
    companyId,
    groupBy,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    groupBy: string;
    filters?: InsightFilterType[];
    includeBWInsights: boolean;
  }) => ['insights', companyId, groupBy, filters, includeBWInsights],
  insightsSearch: ({
    companyId,
    groupBy,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    groupBy: string;
    novaSearchKeyWord: string;
    filters?: InsightFilterType[];
    includeBWInsights: boolean;
  }) => ['insights-search', companyId, groupBy, novaSearchKeyWord, filters, includeBWInsights],
  insightsSummary: ({
    companyId,
    groupBy,
    directory,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    groupBy: string;
    directory: string[];
    filters?: InsightFilterType[];
    includeBWInsights: boolean;
  }) => ['insights-summary', companyId, groupBy, directory, filters, includeBWInsights],
  insightsSummarySearch: ({
    companyId,
    groupBy,
    directory,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    groupBy: string;
    directory: string[];
    novaSearchKeyWord: string;
    filters?: InsightFilterType[];
    includeBWInsights: boolean;
  }) => [
    'insights-summary-search',
    companyId,
    groupBy,
    directory,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  ],
};
